import React from "react";
import { CheckCircle2, Award } from "lucide-react";

/**
 * ============================================================
 * WORKSHOP LEARNING OUTCOMES
 * ============================================================
 * Polished checklist highlighting actionable skills and takeaways.
 * Renders null if learning_outcomes is empty.
 */
export default function WorkshopLearningOutcomes({ learningOutcomes = [] }) {
  if (!learningOutcomes || !Array.isArray(learningOutcomes) || learningOutcomes.length === 0) {
    return null;
  }

  return (
    <section aria-labelledby="learning-outcomes-heading" className="w-full">
      <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 sm:p-8 backdrop-blur-xl shadow-[0_18px_50px_rgba(0,0,0,0.35)] relative overflow-hidden">
        {/* Subtle accent glow in background */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl -z-10 pointer-events-none" />

        {/* Section Header */}
        <div className="flex items-center gap-2.5 mb-6">
          <div className="w-8 h-8 rounded-xl bg-primary/15 border border-primary/25 text-primary flex items-center justify-center flex-shrink-0">
            <Award className="w-4 h-4" />
          </div>
          <div>
            <h2 id="learning-outcomes-heading" className="text-xl sm:text-2xl font-bold tracking-tight text-white">
              What You'll Learn & Build
            </h2>
            <p className="text-xs sm:text-sm text-white/60">
              Core architectural patterns, industry tooling, and production takeaways.
            </p>
          </div>
        </div>

        {/* Outcomes Checklist */}
        <ul className="grid grid-cols-1 gap-3.5 sm:gap-4">
          {learningOutcomes.map((outcome, idx) => (
            <li
              key={idx}
              className="flex items-start gap-3.5 p-3.5 sm:p-4 rounded-2xl border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] transition-colors"
            >
              <div className="w-5 h-5 rounded-full bg-primary/20 text-primary flex items-center justify-center flex-shrink-0 mt-0.5">
                <CheckCircle2 className="w-4 h-4" />
              </div>
              <span className="text-sm sm:text-base text-white/85 leading-relaxed font-normal">
                {outcome}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
